import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-customer-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  @Input() editable = false;
  @Input() customerInfo: any;
  @Input() required = false;
  @Output() customerInfoChange = new EventEmitter<any>();
  @Input() customers = [];
  @Input() disabled = false;
  @Output() select = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();

  showNoRecord: boolean = false;
  limit: number = 20;
  offset: number = 0;
  constructor() {}

  ngOnInit(): void {}

  customerFormatter = (x: {
    FirstName: string;
    LastName: string;
    CustomerTypeId: number;
    BusinessName: string;
  }) =>
    x.CustomerTypeId == 2 ? x.BusinessName : x.FirstName + ' ' + x.LastName;

  searchCustomer = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      map((term) => {
        if (term === '') {
          this.showNoRecord = false;
          return this.customers.splice(this.offset, this.limit);
        } else {
          const result = this.customers.filter((v) => {
            v.FullName = v.FirstName + ' ' + v.LastName;
            return v.CustomerTypeId == 2
              ? v.BusinessName != null &&
                  v.BusinessName.toLowerCase().indexOf(term.toLowerCase()) > -1
              : v.FullName != null &&
                  v.FullName.toLowerCase().indexOf(term.toLowerCase()) > -1;
          });

          this.showNoRecord = result.length === 0 ? true : false;
          result.push({ showMore: true });
          return result.splice(this.offset, this.limit);
        }
      })
    );

  onSelect(customer) {
    this.select.emit(customer);
  }

  change(newValue) {
    if (!newValue) {
      this.onClear();
    } else {
      this.customerInfo = newValue;
      this.customerInfoChange.emit(newValue);
    }
  }

  onClear() {
    this.clear.emit();
  }
}
